import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

enum ViewMode {
  LIST = "list",
  KANBAN = "kanban",
  FORECAST = "forecast",
}

const messages = defineMessages<ViewMode>({
  [ViewMode.FORECAST]: {
    id: "deals.viewMode.forecast",
    defaultMessage: "Forecast view",
    description: "Deals view mode - forecast",
  },
  [ViewMode.KANBAN]: {
    id: "deals.viewMode.kanban",
    defaultMessage: "Board view",
    description: "Deals view mode - kanban",
  },
  [ViewMode.LIST]: {
    id: "deals.viewMode.list",
    defaultMessage: "List view",
    description: "Deals view mode - list",
  },
});

export const getViewModeDisplayName = (intl: IntlShape, viewMode: ViewMode) =>
  getDisplayName(intl, messages, viewMode, "ViewMode");

export default ViewMode;
